import { Box, Stack } from "@mui/material";
import { StatCardTypography } from "Components/UI/StatCard";
import AnalyticsCard from "features/analytics/components/AnalyticsCard";
import {
  AnalyticsChartStatCard,
  AnalyticsStatCard,
  ChartLegend,
} from "features/analytics";
import {
  ApiChartTemplate,
  ApiChartType,
  ApiDimension,
  ApiMetric,
} from "@incendium/api";
import ProductCompareStep from "features/analytics/components/ProductCompareStep";
import { AnalyticsSpacing } from "consts";

export interface IProductCompareProps { }

function ProductCompareWrapper({ }: IProductCompareProps) {
  return (
    <>
      <Box sx={{ gridArea: "1 / 1 / 4 / 6", height: "100%" }}>
        <Stack spacing={AnalyticsSpacing} sx={{ height: "100%" }}>
          <Stack direction={"row"} spacing={AnalyticsSpacing}>
            <Box sx={{ flex: 1 }}>
              <AnalyticsChartStatCard
                hideTrendedSpark
                noToolbar
                chart={{
                  name: "",
                  dimension: [],
                  template: ApiChartTemplate.SNAPSHOT,
                  type: ApiChartType.GRAPH,
                  attributes: [],
                  yAxisKeys: [
                    {
                      key: "l",
                      fields: [ApiMetric.METRIC_PRODUCT_REVENUE],
                    },
                  ],
                  displayOptions: {
                    statTitle: "Total Revenue",
                  },
                }}
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <AnalyticsStatCard
                chart={{
                  name: "",
                  dimension: [ApiDimension.DIMENSION_PRODUCT_NAME],
                  template: ApiChartTemplate.SNAPSHOT,
                  type: ApiChartType.GRAPH,
                  attributes: [],
                  yAxisKeys: [
                    {
                      key: "l",
                      fields: [ApiMetric.METRIC_SALES_REVENUE],
                    },
                  ],
                }}
                renderBody={(data) => (
                  <>
                    <StatCardTypography size="small">
                      Star product in
                      <br /> this time period:
                    </StatCardTypography>
                    <StatCardTypography
                      mt={1}
                      size={data[0]?.name.length < 13 ? "large" : "medium"}
                      lines={1}
                    >
                      {data[0]?.name}
                    </StatCardTypography>
                  </>
                )}
              /></Box>
          </Stack>
          <Box sx={{ flex: 1 }}>
            <AnalyticsCard
              customRightTop={
                <ChartLegend
                  items={["This time Period", "Previous time Period"]}
                />
              }
              chart={{
                name: `Product Page Visits`,
                description: "Dates relate to currently selected time period",
                dimension: [ApiDimension.DIMENSION_SESSION_START_BY_DAY],
                template: ApiChartTemplate.TREND,
                type: ApiChartType.GRAPH,
                attributes: [],
                yAxisKeys: [
                  {
                    key: "l",
                    fields: [ApiMetric.METRIC_PRODUCT_PAGEVIEWS_COUNT],
                  },
                ],
                comparison: true,
                displayOptions: {
                  noFilters: true,
                  noLegend: true,
                  noAttributionToggle: true,
                },
              }}
            />
          </Box>
        </Stack>
      </Box>
      <Box sx={{ gridArea: "1 / 6/ 4 / 13" }}>
        <ProductCompareStep />
      </Box>
    </>
  );
}

export default ProductCompareWrapper;
